<template>
  <div>
    <header>
      角色名称：
      <el-input v-model="searchKey" placeholder="请输入角色名称" style="width: 340px"></el-input>状态：
      <el-select v-model="status" placeholder="请选择">
        <el-option label="全部" :value="-1"></el-option>
        <el-option label="有效" :value="1"></el-option>
        <el-option label="无效" :value="2"></el-option>
      </el-select>
      <el-button type="primary" icon="el-icon-search" style="margin-left: 10px" @click="handlerSearch">查询</el-button>
      <el-button type="primary" @click="open">新增</el-button>
    </header>
    <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
      <el-table-column type="index" label="序号" width="180"></el-table-column>
      <el-table-column prop="roleName" label="角色名称" width="180"></el-table-column>
      <el-table-column label="功能授权" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="getModules(scope.row)">功能授权配置</el-button>
        </template>
      </el-table-column>
      <el-table-column prop="userCount" label="角色人数" align="center"></el-table-column>
      <el-table-column label="状态" align="center">
        <template slot-scope="scope">{{ scope.row.status == 1 ? '有效' : '无效' }}</template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="handleClick(scope.row)">编辑</el-button>
          <el-button type="text" @click="handleDel(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="tc" style="margin-top:20px">
      <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
        :page-sizes="[10, 20, 50]" :page-size="pagesize" layout="total, sizes, prev, pager, next, jumper"
        :total="totalCount"></el-pagination>
    </div>

    <el-dialog :title="editId ? '编辑' : '新增'" :visible.sync="addDialogVisible" width="40%" center
      :close-on-click-modal="false" @close="dialogCloseFun">
      <el-form ref="ruleForm" :model="trainForm" label-width="160px" :rules="rules">
        <el-row>
          <el-col :span="24">
            <el-form-item label="角色名称:" prop="roleName">
              <el-input v-model="trainForm.roleName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="显示顺序:">
              <el-input v-model="trainForm.roleSort"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="24">
            <el-form-item label="有效状态:" prop="status">
              <el-radio v-model="trainForm.status" :label="1">有效</el-radio>
              <el-radio v-model="trainForm.status" :label="2">无效</el-radio>
            </el-form-item>
          </el-col>
        </el-row>

        <el-form-item>
          <el-button type="primary" @click="submitForm('ruleForm')">确定</el-button>
          <el-button @click="resetForm('ruleForm')">取消</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>

    <newAuthorization ref="authorization" :treeMenus="treeMenus" @selectModules="selectModules" :propsKey="propsKey" name="menuName"/>
  </div>
</template>

<script>
import {
  provinceAndCityData
} from 'element-china-area-data'
import newAuthorization from '@/components/newAuthorization.vue'
import {
  Api_role,
  Api_SuperAdmin,
  Api_Company,
} from '@/api/api'
import { getStore } from '@/util/store'
import mixin_dialog from '@/mixins/dialog.js';
export default {
  components: {
    newAuthorization
  },
  mixins: [mixin_dialog],
  data() {
    return {
      treeMenus:[],
      options: provinceAndCityData,
      selectedOptions: [],
      searchKey: "",
      status: -1,
      authorizationShow: false,
      tableData: [],
      currentPage: 1,
      pagesize: 10,
      totalCount: 0,
      addDialogVisible: false,
      trainForm: {
        roleName: '',
        roleSort: '',
        status: 1,
      },
      rules: {
        roleName: [{
          required: true,
          message: "请输入角色名称",
          trigger: "blur",
        }],
        status: [{
          required: true,
          message: "请选择有效状态",
          trigger: "blur",
        }],
      },
      companyId: getStore({ name: 'companyId' }),
      haveID: '',
      propsKey: [],
      itemId: '',
      projectId: getStore({ name: 'projectId' }),
      editId: 0,
    };
  },
  created() {
    this.handlerSearch()
  },
  methods: {
    // 获取公司所有菜单
    getModules(val) {
      this.companyId = val.authorityCompanyId;
      this.itemId = val.id
      let params = {
        companyId: 0,
        menuName: "",
        parentId: 0
      }
      Api_Company.getCompanyMenus(params).then(res => {
        this.treeMenus = res.data.data
        this.getMenuSelect(val.id)
        // if (res.data.data && res.data.data.authorityMenuId) {
        //   this.haveID = res.data.data.authorityMenuId
        //   this.getMenuSelect(val.id)
        // }
      })
    },
    getMenuSelect(id) {
      Api_role.getProjectSubSelect(id).then(res => {
        const result = res.data
        this.propsKey = []
        if (result.statusCode == 200) {
          result.data.map(item => {
            this.propsKey.push(item.authorityMenuId)
          })
          console.log(this.propsKey);
          this.$refs.authorization.open()
        } else {
          this.propsKey = []
          this.$showMessage("失败", result.errors);
        }
      })
    },
    selectModules(modules) {
      let params = {
        roleId: this.itemId,
        menuId: [],
        operateIds: '1,2', // TODO 页面需要增加复选框列表
        projectId: this.projectId,
        authorityCompanyId: this.companyId,
      }
      modules.map(item => {
        params.menuId.push(item)
      })
      Api_role.setProjectModules(params).then(res => {
        this.$message({
          type: "success",
          message: "设置成功!",
        });
        this.authorizationShow = false
      })
    },
    handleSizeChange(size) {
      this.pagesize = size;
      this.handlerSearch()
    },
    handleCurrentChange(currentPage) {
      this.currentPage = currentPage;
      this.handlerSearch()
    },
    open(val) {
      // this.resetForm()
      this.trainForm = {
        roleName: '',
        roleSort: '',
        status: 1,
      }
      this.addDialogVisible = true
    },
    closeAuthor(val) {
      this.authorizationShow = val
      this.propsKey = []
      this.companyId = ''
      this.haveID = ''
    },
    handleClick(val) {
      this.editId = val.id
      Api_role.detail(val.id).then(res => {
        this.trainForm = res.data.data
        this.addDialogVisible = true
        // debugger
      })
    },
    handleDel(val) {
      this.$confirm('是否删除此部门?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Api_role.delRole(val.id).then(res => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          this.handlerSearch()
        })
      })
    },
    handleChange(value) {
      console.log(value)
    },
    handlerSearch() {
      let params = {
        status: this.status,
        projectId: this.projectId,
        roleName: this.searchKey,
        companyId: this.companyId,
        pageSize: this.pagesize,
        pageIndex: this.currentPage
      }
      Api_role.getRoleList(params).then(res => {
        const result = res.data
        if (result.statusCode == 200) {
          this.tableData = result.data.tList
          this.totalCount = result.data.totalCount
        }
      })
    },
    addRole() {
      let params = {
        projectId: this.projectId,// 公司默认是0,项目是1
        authorityCompanyId: this.companyId,
        roleName: this.trainForm.roleName,
        status: this.trainForm.status,
        roleSort: Number(this.trainForm.roleSort)
      }
      if (this.trainForm.id) {
        params.id = this.trainForm.id
        Api_role.editRole(params).then(res => {
          this.addDialogVisible = false
          const result = res.data
          if (result.statusCode == 200) {
            this.handlerSearch()
          }
        })
      } else {
        Api_role.addRole(params).then(res => {
          this.addDialogVisible = false
          const result = res.data
          if (result.statusCode == 200) {
            this.handlerSearch()
          }
        })
      }

    },
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.addRole()
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    resetForm() {
      this.addDialogVisible = false
      this.trainForm = {}
      this.editId = 0;
    },
  },
};
</script>